import Grid from '@/global/components/ui/Grid'
import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import jwt_decode from 'jwt-decode'
import { useNavigate } from 'react-router-dom'
import { auth, AvaliacaoSchema } from 'service/api'
import { toast } from 'sonner'
import { z } from 'zod'

const schema = z
    .object({
        senha: AvaliacaoSchema.shape.senha,
        confirmar: AvaliacaoSchema.shape.confirme,
    })
    .refine(({ senha, confirmar }) => senha === confirmar, {
        message: 'As senhas não conferem',
        path: ['confirmar'],
    })

export default function AlterarSenhaHash() {
    const navigate = useNavigate()
    const { mutateAsync } = auth.alterar.mutations.useCreate()

    const hash = new URLSearchParams(window.location.search).get('hash')

    if (!hash) return navigate('/') as never

    let email: string
    try {
        email = jwt_decode<{ email: string }>(hash).email
    } catch (_) {
        return (
            <Dialog.Root>
                <Dialog.Title>Erro</Dialog.Title>
                <Dialog.Content>
                    O link de recuperação de senha é inválido.
                </Dialog.Content>
                <Dialog.Actions>
                    <Dialog.Actions.SecondaryButton>
                        Voltar
                    </Dialog.Actions.SecondaryButton>
                </Dialog.Actions>
            </Dialog.Root>
        )
    }

    const handleSubmit = async ({ senha }: z.infer<typeof schema>) => {
        await mutateAsync(
            { senha, hash },
            {
                onSuccess: () => {
                    toast.success('Senha alterada com sucesso')
                    navigate('/')
                },
                onError: e => {
                    toast.error(e.message)
                },
            },
        )
    }

    return (
        <Dialog.Root onSubmit={handleSubmit} schema={schema} width="md">
            <Dialog.Title>Alterar senha</Dialog.Title>
            <Dialog.Content>
                <Grid container>
                    <Grid item xs={12}>
                        <FormField
                            name="email"
                            label="Email"
                            defaultValue={email}
                            disabled
                            autoComplete="username"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            name="senha"
                            label="Senha"
                            type="password"
                            autoComplete="new-password"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            name="confirmar"
                            label="Confirmar senha"
                            type="password"
                            autoComplete="new-password"
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
